var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectionHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4723 8.17881L3.43899 2.88855C2.90826 2.57774 2.12549 2.92564 2.12549 3.70974L2.12549 14.2903C2.12549 15.0739 2.90743 15.4219 3.43814 15.1119L12.4723 9.82119L12.4734 9.82056C13.0825 9.46273 13.082 8.53614 12.4723 8.17881ZM14.9522 10.8239C16.3493 10.0057 16.3493 7.99425 14.9522 7.17606L3.20315 0.295372C1.78623 -0.534431 9.32575e-07 0.482687 8.61036e-07 2.11931L2.59507e-07 15.8807C1.87968e-07 17.5173 1.78623 18.5344 3.20315 17.7046L14.9522 10.8239Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4723 8.17881L3.43899 2.88855C2.90826 2.57774 2.12549 2.92564 2.12549 3.70974L2.12549 14.2903C2.12549 15.0739 2.90743 15.4219 3.43814 15.1119L12.4723 9.82119L12.4734 9.82056C13.0825 9.46273 13.082 8.53614 12.4723 8.17881Z",
    fill: "#6E49FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionHandle);
export default __webpack_public_path__ + "static/media/connection-handle.0feff92c5aaa12bbc8266c4aeaddaa59.svg";
export { ForwardRef as ReactComponent };